import script from "./OrderForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderForm.vue?vue&type=script&setup=true&lang=js"

import "./OrderForm.vue?vue&type=style&index=0&id=6bd0000a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd0000a"]])

export default __exports__